module.exports = __webpack_public_path__ + "files/943a7f1e047cc1cc4f7f6893f8f83365.png";